import i18n from '@/plugins/i18n'

export const reports=[
    {
        value: '1',
        text: i18n.t('mentora_student_course_registration_report'),
        permission: 'eslreport_studentcourseregistration'
    },
     {
       value: '2',
       text: i18n.t('history_of_module'),
       permission: 'eslreport_historyofmodule'
   },
    {
        value: '3',
        text: i18n.t('mentora_agency_report'),
        permission: 'eslreport_agency'
    },
    {
        value: '4',
        text: i18n.t('enrollment_report_ce'),
        permission: 'eslreport_historyofmodule'
    },
    {
        value: '5',
        text: i18n.t('enrollment_report_semi_intensive'),
        permission: 'eslreport_historyofmodule'
    },
]
